import { userMapper } from '../mappers/user-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const userRepository = {
    async get() {
        try {
            const data = await apiClient.get({
                url: 'auth/profile'
            });

            return userMapper.toDomain(data);
        } catch (error) {
            throw error;
        }
    },

    async delete() {
        try {
            await apiClient.post({
                url: 'auth/profile/delete',
                isCheckAccessToken: true
            });

            return true;
        } catch (error) {
            logError(error);

            return false;
        }
    }
};
  
export {
    userRepository
};
